export enum PERMISSIONS {
  AGENT_MANAGEMENT_PERFORMANCE_READ = 'sv.agent.management.performance.read',
  TASK_POOL_UPLOAD_TASK_WRITE = 'sv.task.pool.taskUpload.write',
  TASK_POOL_UPLOAD_TASK_READ = 'sv.task.pool.taskUpload.read',
  TASK_QUEUE_GROUP_REORDER_READ = 'sv.task.queueGroup.reorder.read',
  TASK_AGENT_AMOUNT_READ = 'sv.task.agentAmount.read',
  TASK_AGENT_MANAGEMENT_DASHBOARD_READ = 'sv.agent.management.dashboard.read'
}
